// src/features/flow-builder/samplePayload.ts

export const samplePayload = `{
  "bookingNumber": "BKG-2026-001",
  "customer": {
    "name": "ACME Logistics",
    "code": "ACME"
  },
  "containers": [
    {
      "containerNo": "MSCU1234567",
      "type": "40HC"
    },
    {
      "containerNo": "MSCU7654321",
      "type": "20DV"
    }
  ],
  "events": [
    {
      "eventType": "GateIn",
      "eventDate": "2026-01-12",
      "location": "Rotterdam"
    },
    {
      "eventType": "Loaded",
      "eventDate": "2026-01-13",
      "location": "Rotterdam"
    }
  ]
}`;